/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

import React from "react";
import Grid from "@mui/material/Grid";
import bgImage from "../../nvidia-background.jpeg"

function BlankNode() {

  const itemCustomizationStyle = {
    overflow: "auto",
    width: "100vw",
    height:"815px",
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "bottom",
    display: "flex",
  };

  return (
    <Grid
      sx={itemCustomizationStyle}
      container
      justifyContent='center'
      alignItems='center'
    />
  );
}

export default BlankNode;
